import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Typography, Container } from '@mui/material';
import useLocales from 'hooks/useLocales';
import Image from 'components/image/Image';
import { useTenantInfo } from 'hooks/useTenantInfo';

import './Index.scss';

const AcceptPrivacy = () => {
  const { t } = useLocales();
  const { tenantLogo } = useTenantInfo();

  return (
    <div className="accept-privacy-page__container">
      <div className="accept-privacy-page__card">
        <div className="accept-privacy-page__card-content">
          <div className="accept-privacy-page__logo">
            {tenantLogo ? (
                <Image url={tenantLogo} width={180} height={80} />
            ) : (
              <Image name="new-rec-logos.svg" width={60} height={60} />
            )}
          </div>
          
          <h1 className="accept-privacy-page__title">
            {t('We are glad that you accepted our privacy terms')}
          </h1>
          
          <p className="accept-privacy-page__message">
            {t('We will check-in with you in 11 months to see if you changed your ideas or not!')}
          </p>

          <Button
            component={RouterLink}
            to="/"
            variant="contained"
            size="large"
            className="accept-privacy-page__button"
          >
            {t('Go to Home')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AcceptPrivacy;
